import React, { useEffect, useState } from "react";
import UserTable from "../components/users/UserTable";
import UserModal from "../components/users/UserModal";
import ChangePasswordModal from "../components/users/ChangePasswordModal";
import CreateUserButton from "../components/users/CreateUserButton";
import { getUsers } from "../services/userService";

const UsersPage = () => {
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [openModal, setOpenModal] = useState(false);
    const [passwordModal, setPasswordModal] = useState(false);

    const fetchUsers = async () => {
        try {
            const res = await getUsers();
            setUsers(res.data);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    return (
        <main className="min-h-screen p-6">
            <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
                {/* Header */}
                <div className="flex justify-between items-center border-b pb-5">
                    <CreateUserButton
                        onClick={() => {
                            setSelectedUser(null);
                            setOpenModal(true);
                        }}
                    />
                </div>

                {/* Table */}
                <div className="mt-8 bg-white">
                    <UserTable
                        users={users}
                        onEdit={(user) => {
                            setSelectedUser(user);
                            setOpenModal(true);
                        }}
                        onPassword={(user) => {
                            setSelectedUser(user);
                            setPasswordModal(true);
                        }}
                    />
                </div>
            </div>

            {/* Edit/Create Modal */}
            <UserModal
                open={openModal}
                user={selectedUser}
                onClose={() => setOpenModal(false)}
                refresh={fetchUsers}
            />

            {/* Password Modal */}
            <ChangePasswordModal
                open={passwordModal}
                user={selectedUser}
                onClose={() => setPasswordModal(false)}
            />
        </main>
    );
};

export default UsersPage;